import { render, staticRenderFns } from "./VersionCard.vue?vue&type=template&id=2b3b0c53&"
import script from "./VersionCard.vue?vue&type=script&lang=ts&"
export * from "./VersionCard.vue?vue&type=script&lang=ts&"
import style0 from "./VersionCard.vue?vue&type=style&index=0&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports